import { getBroadcastRouteMatch } from '@shoflo/studio-redux/utils';
import { StudioLogger } from '@studio/logger/StudioLogger';
import { shouldHaveFeature } from '@studio/feature.flags/featureFlags';
import { VENDOR_AGORA } from '@studio/constants/Vendor';
import { stopContentShare } from '@studio/chime/audioVideo/audioVideoHelpers';
import { getApiClient } from '../getApiClient';
import setScreenShareActive from 'actions/Broadcast/setScreenShareActive';

const LOG = new StudioLogger('syncScreenShare');

/**
 * Syncs the screen share state by fetching the current sources and checking if the screen share source is present.
 * If the screen share source is missing while screen sharing is active, it stops the screen share and updates the state.
 *
 * @param dispatch
 * @param getState
 */
export default async function syncScreenShare(dispatch, getState) {
  const apiClient = getApiClient();
  const match = getBroadcastRouteMatch(getState);
  const isAgoraVendor =
    shouldHaveFeature('studio.meetingVendor') === VENDOR_AGORA;

  if (match && !isAgoraVendor) {
    const { teamId, eventId, broadcastId } = match.params;
    const {
      isScreenShareActive,
      meeting: { meetingSession, attendeeResponse }
    } = getState();

    if (isScreenShareActive) {
      try {
        const sources = await apiClient.broadcast.getSources(
          teamId,
          eventId,
          broadcastId,
          {
            size: 200
          }
        );
        const attendeeId = attendeeResponse.Attendee.AttendeeId;
        const screenShareId = `${attendeeId}#content`;
        const screenShareSource = sources.items.find(
          source => source.value === screenShareId
        );

        if (!screenShareSource) {
          LOG.warn(
            `Screen share de-sync detected. Stopping screen share. ScreenShareId: ${screenShareId}`
          );
          stopContentShare(meetingSession);
          dispatch(setScreenShareActive(false));
        }
      } catch (error) {
        LOG.error('Error syncing screen share state:', error);
      }
    }
  }
}
